import type Insured from '@/modules/common/common/models/APP/Insured'
import CommonMapper from '@/modules/core/mappers/CommonMapper'

import TravelSavePolicyHolderRequest from '@/modules/travel/hiring/models/MID/requests/TravelSavePolicyHolderRequest'

export default class SavePolicyHolderMapper {
  static toRequest(quotationId: string, holder: Insured): TravelSavePolicyHolderRequest {
    const dataProtection = {
      dataTransfer: holder.dataTransfer,
      thirdPartyTelephoneAdvertising: holder.thirdPartyTelephoneAdvertising,
      thirdPartyWrittenAdvertising: holder.thirdPartyWrittenAdvertising
    }

    return new TravelSavePolicyHolderRequest({
      quotationId,
      policyHolder: {
        name: holder.userDetails.name,
        firstSurname: holder.userDetails.surname1,
        secondSurname: holder.userDetails.surname2,
        birthDate: CommonMapper.toMiddlewareDate(holder.userDetails.birthDate),
        sex: holder.userDetails.gender,
        street: holder.addressDetails.address,
        city: holder.addressDetails.city,
        house: holder.addressDetails.roadNumber,
        postalCode: holder.addressDetails.postalCode,
        province: holder.addressDetails.province,
        houseType: holder.addressDetails.houseType,
        gateway: holder.addressDetails.gateway,
        stair: holder.addressDetails.stair,
        floor: holder.addressDetails.floor,
        doorway: holder.addressDetails.doorway,
        restAddres: holder.addressDetails.addressExtra,
        streetType: holder.addressDetails.streetType || 'CALLE',
        addressNormalice: holder.addressDetails.addressNormalize,
        email: holder.userDetails.email,
        prefix: holder.userDetails.prefix,
        mobilePhone: holder.userDetails.phone,
        sendPrecontractualDocuments: holder.preContractualDocumentChecked
      },
      dataProtection: !holder.thirdPartiesAnswered ? dataProtection : undefined
    })
  }
}
